import { RootState } from '../rmsStore';

export function getReferenceDataReducer(state: RootState): ReferenceDataState {
  return state.referenceDataReducer;
}

